const LOGO_SRC = "/img/navbar-logo.png";

export default function VELogo({ size = 32, className = "" }) {
  return (
    <img
      src={LOGO_SRC}
      alt="Veer Electrical"
      className={`select-none object-contain ${className}`}
      style={{ height: size, width: "auto" }}
      draggable={false}
    />
  );
}
